import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment';

import { currencySymbolForPDF } from '../../../services/orderService';
import { formatMoney } from '../../../util/numberUtils';

import orderStyles from './OrderStyles';

const textColor = '#2A4494';

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '60%'
  },
  invoiceDetail: {
    flexDirection: 'column'
  },
  label: {
    paddingBottom: 3,
    fontSize: 12,
    fontStyle: 'bold',
    color: textColor
  },
  desc: {
    fontSize: 10,
    textAlign: 'center'
  },
  headerDeliveryContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    width: '100%'
  }
});


const InvoiceOrderDetails = ({invoice, retailerInfo}) => {
  const symbol = currencySymbolForPDF(invoice);
  const currency = invoice.currency || retailerInfo.currency_code;
  const dateIssued = invoice.created_at ? moment(invoice.created_at).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
  const orderNumber = invoice.sequential_number ? `${invoice.sequential_number}`: invoice.order_id;

  const getDeliveryMethodLabel = (deliveryMethod) => {
    switch(deliveryMethod) {
      case 'send_order':
        return 'Envío a Domicilio';
      case 'store_pickup':
        return 'Recoger en Tienda';
      default:
        return null;
    }
  }

  const deliveryMethodLabel = getDeliveryMethodLabel(invoice.delivery_method);

  const widthForAmmount = (text) => {
    if (String(text).length < 8) return '31%';
    return '42%';
  }

  return (
    <Fragment>
      <View style={styles.headerContainer}>
        <View style={[styles.invoiceDetail, {width: '33%'}]}>
          <Text style={styles.label}>Fecha emisión</Text>
          <Text style={styles.desc}>{dateIssued}</Text>
        </View>

        <View style={[styles.invoiceDetail, {width: '25%'}]}>
          <Text style={styles.label}>No. Orden</Text>
          <Text style={styles.desc}>{orderNumber}</Text>
        </View>

        <View style={[styles.invoiceDetail, {width: widthForAmmount(invoice?.total), textAlign: 'center'}]}>
          <Text style={[styles.label]}>Total</Text>
          <View style={[orderStyles.row, {flexWrap: 'wrap', justifyContent: 'center'}]}>
            <Text style={[styles.desc]}>{symbol}{formatMoney(invoice?.total)}</Text>
            <Text style={orderStyles.currency}> {currency}</Text>
          </View>
            { deliveryMethodLabel &&
              <View style={styles.headerDeliveryContainer}>
                <View style={[styles.invoiceDetail, {width: '100%'}]}>
                  <Text style={styles.label}>Entrega</Text>
                  <Text style={styles.desc}>{deliveryMethodLabel}</Text>
                </View>
              </View>
            }
        </View>
      </View>
    </Fragment>
  );
}

export default InvoiceOrderDetails;
